import { m } from '@hub/messages';
import type { BannerInboxAction, SiteHeaderBannerInbox } from '@platform/ui';
import { useBannerActions, useBannerInbox } from './useBanners';

export function useBannerInboxMenu(): SiteHeaderBannerInbox {
  const banners = useBannerInbox();
  const { dismissBanner } = useBannerActions();

  return {
    triggerAriaLabel: m.banners_inbox_trigger_label(),
    closeLabel: m.banners_inbox_close_label(),
    title: m.banners_inbox_title(),
    emptyStateLabel: m.banners_inbox_empty_state(),
    items: banners.map((banner) => {
      const actions: BannerInboxAction[] = [];
      if (!banner.persistent && !banner.dismissed) {
        actions.push({
          label: m.banners_inbox_mark_read(),
          variant: 'secondary',
          onClick: () => dismissBanner(banner.id),
          closeOnClick: false,
        });
      }
      if (banner.action) {
        actions.push(...banner.action.map((action) => ({ label: action.label, onClick: action.onClick })));
      }
      return {
        id: banner.id,
        title: banner.title,
        description: banner.description,
        read: banner.dismissed,
        actions,
      };
    }),
  };
}
